// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"aab2a582","787":"cb45751b","868":"bac395cd"}[chunkId] + ".chunk.js";
};